// ** React Imports
import React, { useState } from 'react'

// ** MUI Imports
import { Copy } from 'react-feather'
import { useLocale } from 'src/lib/hooks/useLocal'
import { alertSeverites } from 'src/lib/utils/constants'
import Alerts from '../feedback-and-dialog/Alerts'

interface CopyTextButtonProps {
  text: string
  children?: JSX.Element
  message?: string
  disabled?: boolean
}

const CopyTextButton: React.FC<CopyTextButtonProps> = ({ text, children, message, disabled = false }) => {
  const { t } = useLocale()
  const [openAlert, setOpenAlert] = useState<string>('')
  const [alertMessage, setAlertMessage] = useState<string>('')

  const doCopy = () => {
    if (disabled) return
    navigator.clipboard.writeText(text)
    handleAlerts(alertSeverites.SEVERITY_SUCCESS, t('alert_link_copied'))
  }

  // ** Alert Handlers ** //
  const handleAlerts = (severity: string, message?: string) => {
    setOpenAlert(severity)
    message && setAlertMessage(message)
  }

  const handleCloseAlert = (_event: any, reason: string) => {
    if (reason === 'clickaway') {
      return
    }
    handleAlerts('')
  }
  if (disabled) {
    return children
  }

  return (
    <>
      <div className='flex items-center cursor-pointer' onClick={doCopy}>
        {children ? children : <Copy className='w-3 h-3 mr-1' />}
      </div>
      {/* Alerts */}
      {openAlert.length ? (
        <Alerts
          open={Boolean(openAlert.length)}
          duration={2000}
          closeHandler={handleCloseAlert}
          severity={openAlert}
          message={message ?? alertMessage}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default CopyTextButton
